<script>
    import { navigateTo } from 'svelte-router-spa'
    import { cellphone } from '../../store.js'

    function nxt() {
        cellphone.set($cellphone)
        navigateTo('idNumber')
    }
</script>

<main>
    <div class="body">
        <h1>Enter your cellphone number</h1>
        <p>Ilagay ang iyong cellphone number</p>
        <input type="text" bind:value={$cellphone}>

        {#if $cellphone}
        <a class="btn btn-primary" on:click={nxt}>Next</a>
        {/if}
    </div>
</main>